import {
    GridComparatorFn,
    GridRenderCellParams,
    GridSortCellParams,
} from "@mui/x-data-grid-pro";
import _ from "lodash";
import moment from "moment";
import { shouldApplyTimestampHeuristic, standardDateFormat } from "utils/DateTimeUtils";
import { applyTimestampHeuristic } from "../ColumnTypes/DateColTypes";

export const DateFormatterConvertToLocalAndIgnoreTime = (param: GridRenderCellParams) => {
    if (!param.value) {
        return "";
    }

    const momentDate = shouldApplyTimestampHeuristic(param.value) ? moment.utc(applyTimestampHeuristic(param.value)).local() : moment.utc(param.value).local();

    return standardDateFormat(momentDate);
};

export const DateObjectFromUTCTimeGetter = (_, row, column) => {
    const value = row[column.field];

    if (!value) {
        return "";
    }

    // Returns a date object using the UTC time provided
    return moment.utc(value).toDate();
};

export const DateComparator: GridComparatorFn = (
    v1,
    v2,
    param1: GridSortCellParams,
    param2: GridSortCellParams,
): number => {
    const row1 = param1.api.getRow(param1.id);
    const row2 = param2.api.getRow(param2.id);

    const p1 = _.get(row1, param1.field)?.toString();
    const p2 = _.get(row2, param2.field)?.toString();

    if (!p1) return 1;
    if (!p2) return -1;
    return p1.localeCompare(p2);
};
